/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Directory_Tools_Generator_FromInputs */

const en_directory_tools_generator_from = /** @type {(inputs: Directory_Tools_Generator_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.credits} credits`)
};

const zh_directory_tools_generator_from = /** @type {(inputs: Directory_Tools_Generator_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} 积分起`)
};

/**
* | output |
* | --- |
* | "From {credits} credits" |
*
* @param {Directory_Tools_Generator_FromInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_generator_from = /** @type {((inputs: Directory_Tools_Generator_FromInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Generator_FromInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_generator_from(inputs)
	return zh_directory_tools_generator_from(inputs)
});
export { directory_tools_generator_from as "directory.tools.generator_from" }